import { useMemo } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchVolumes } from "../api/periodicalIssueService";
import { AFTER_MUTATION } from "../utils/afterMutation";
import { findCurrentVolume } from "../utils/volumeWindow";
import { PERIODICAL_LIBRARY_DETAIL_KEY } from "./usePeriodicalLibraryActions";
export var PERIODICAL_VOLUMES_KEY = "periodicalVolumes";
export var ISSUE_MATRIX_KEY = "issueMatrix";
export var EMPTY_VOLUMES = [];
export var usePeriodicalVolumes = function (plId, enabled) {
    if (enabled === void 0) { enabled = true; }
    var kyInstance = useOkapiKy();
    return useQuery([PERIODICAL_VOLUMES_KEY, plId], function () { return fetchVolumes(kyInstance, plId); }, { enabled: enabled && !!plId });
};
export var useSelectedVolume = function (plId, chosenVolumeId) {
    var _a = usePeriodicalVolumes(plId), data = _a.data, isLoading = _a.isLoading, isError = _a.isError;
    var volumes = data !== null && data !== void 0 ? data : EMPTY_VOLUMES;
    var selectedVolume = useMemo(function () {
        var _a, _b;
        return (_b = (_a = volumes.find(function (volume) { return volume.id === chosenVolumeId; })) !== null && _a !== void 0 ? _a : findCurrentVolume(volumes)) !== null && _b !== void 0 ? _b : volumes[0];
    }, [volumes, chosenVolumeId]);
    return { volumes: volumes, isLoading: isLoading, isError: isError, selectedVolume: selectedVolume };
};
export var invalidateVolumeViews = function (queryClient) {
    queryClient.invalidateQueries([PERIODICAL_VOLUMES_KEY], undefined, AFTER_MUTATION);
    queryClient.invalidateQueries([ISSUE_MATRIX_KEY], undefined, AFTER_MUTATION);
    // the detail's anchor mismatch is computed from the volumes
    queryClient.invalidateQueries([PERIODICAL_LIBRARY_DETAIL_KEY], undefined, AFTER_MUTATION);
};
